define('home/views/EmailConfirmedModalContentView',[
    'underscore',

    'core/utils',

    'home/mixins/asModal',

    'home/templates/emailConfirmedModalContent',

    'home/views/SettingsAccountFormView',
], function (
    _,

    coreUtils,

    asModal,

    emailConfirmedModalContentTemplate,

    SettingsAccountFormView
) {
    'use strict';

    var EmailConfirmedModalContentView = SettingsAccountFormView.extend({
        template: emailConfirmedModalContentTemplate,

        updateStatus: function (status) {
            SettingsAccountFormView.prototype.updateStatus.apply(this, arguments);

            // close modal on successful save
            if (status === 'is-saved') {
                var animationEndEvent = coreUtils.animationEndEvent;
                var closeModal = _.bind(this.closeModal, this);

                if (animationEndEvent)
                    this.$saveStatus.one(animationEndEvent, '.icon-checkmark', closeModal);
                else
                    _.delay(closeModal, 1500);
            }
        },

        getFormData: function () {
            var formData = SettingsAccountFormView.prototype.getFormData.call(this);

            // merge in password and old_password with blank values as the settings api
            // endpoint requires it
            return _.defaults(formData, {
                password: '',
                old_password: '',
            });
        },
    });

    asModal.call(EmailConfirmedModalContentView.prototype);

    return EmailConfirmedModalContentView;
});

